export function disposeObject(object) {
  const geometries = new Set();
  const materials = new Set();
  const textures = new Set();
  object.traverse(child => {
    if (child.geometry) geometries.add(child.geometry);
    if (child.material) {
      (Array.isArray(child.material) ? child.material : [child.material]).forEach(material => {
        materials.add(material);
        Object.values(material).forEach(value => {
          if (value && value.isTexture) textures.add(value);
        });
      });
    }
  });
  geometries.forEach(value => value.dispose());
  materials.forEach(value => value.dispose());
  textures.forEach(value => value.dispose());
  if (object.parent) object.parent.remove(object);
}
